import React, { PureComponent, Fragment } from 'react';
import { Descriptions } from 'antd';
import { handleProperty } from '../../../../config/resourcePropertiesConfig';
class SingleResourcePropertiesTable extends PureComponent {
  state = {};
  render() {
    let { resourceProperties, provider, service } = this.props;
    return (
      <Fragment>
        <Descriptions
          title={<span style={{ fontWeight: 500, fontSize: '19px' }}>Properties</span>}
          size="small"
          column={1}
        >
          {Object.keys(resourceProperties).map((key, i) => {
            const property = handleProperty(provider, service, key, resourceProperties[key]);
            if (property) {
              if (typeof property.value === 'object') {
                return Object.keys(property.value).map((item, i) => {
                  return (
                    <Descriptions.Item
                      key={`${item}-${i}`}
                      style={{ fontSize: '13px', maxWidth: '182px' }}
                      label={item}
                    >
                      {property.value[item]}
                    </Descriptions.Item>
                  );
                });
              } else {
                return (
                  <Descriptions.Item
                    style={{ fontSize: '13px', maxWidth: '182px' }}
                    label={property?.name}
                    key={`${property?.value}-${i}`}
                  >
                    <span style={{ fontSize: '13px' }}>
                      {property?.value === '' ? (
                        <span style={{ marginLeft: '61px' }}>-</span>
                      ) : (
                        property?.value
                      )}
                    </span>
                  </Descriptions.Item>
                );
              }
            } else {
            }
          })}
        </Descriptions>
      </Fragment>
    );
  }
}

export default SingleResourcePropertiesTable;
